import RewardStoreModal from './RewardStoreModal'
export default RewardStoreModal
